/**
 * 头像和昵称设置提示类型
 */
export enum InfoSettingType {
  /** 头像或昵称为空,提醒用户设置 */
  EMPTY = 'EMPTY',
  /** 头像是 OA 头像,提醒用户外露风险 */
  OA = 'OA'
}
